import axios from 'axios'; 
import ExternalEndPoint from '../constants/externalEndPoints';


const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_UMBRACO_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const sendActionStatus = async (token: string, status:boolean, action:string, message?:string | "", redirection?:string | ""): Promise<any> => { 
  try {   
    const response = await axiosInstance.get(ExternalEndPoint.Actions.Actions, {
        params: { token, status, action, message,redirection  }
      });  
    return response;
    
  } catch (error) {
    throw new Error('Failed to call external api');
  }
};  

export const externalApiService = {
    sendActionStatus
};
